import { useState } from "react";
import { ChevronsUpDown, Plus, Search } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { money } from "@/lib/format";

// Búsqueda rápida de clientes
export const ClientPicker = ({ clients, value, onPick, onNew }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex gap-2">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" className="flex-1 justify-between" data-testid="client-picker-btn">
            <span className="truncate">{value?.name || "Seleccionar cliente…"}</span>
            <ChevronsUpDown className="w-4 h-4 opacity-60" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="p-0 w-[min(92vw,420px)] bg-[#120E2E] border-[#271E56]" align="start">
          <Command>
            <CommandInput placeholder="Buscar cliente…" data-testid="client-picker-search" />
            <CommandList>
              <CommandEmpty>Sin resultados</CommandEmpty>
              <CommandGroup>
                {clients.map((c) => (
                  <CommandItem key={c.id} value={`${c.name} ${c.id_number} ${c.email}`} onSelect={() => { onPick(c); setOpen(false); }} data-testid="client-picker-option">
                    <div>
                      <div className="text-white">{c.name}</div>
                      <div className="text-xs text-slate-400 mono">{c.id_number}</div>
                    </div>
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
      <Button variant="outline" size="icon" onClick={onNew} title="Nuevo cliente" data-testid="client-picker-new"><Plus className="w-4 h-4" /></Button>
    </div>
  );
};

// Búsqueda rápida de artículos del inventario
export const ProductPicker = ({ products, onPick }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button className="btn-neon" data-testid="add-item-btn"><Search className="w-4 h-4 mr-1" />Agregar del inventario</Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[min(92vw,480px)] bg-[#120E2E] border-[#271E56]" align="start">
        <Command>
          <CommandInput placeholder="Buscar por nombre o código…" data-testid="product-picker-search" />
          <CommandList>
            <CommandEmpty>Sin resultados</CommandEmpty>
            <CommandGroup>
              {products.map((p) => (
                <CommandItem key={p.id} value={`${p.code} ${p.name}`} onSelect={() => { onPick(p); setOpen(false); }} data-testid={`product-option-${p.code}`}>
                  <div className="flex-1 min-w-0">
                    <div className="text-white truncate">{p.name}</div>
                    <div className="text-xs text-slate-400 mono">{p.code} · {p.type === "servicio" ? "Servicio" : `Stock ${p.stock}`}</div>
                  </div>
                  <span className="mono text-xs text-[#00F0FF]">{money(p.sale_price)}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
